export const experiment = {
  methods: {
    handleSetExperimentNotification(responseMessage) {
      const notificationType = responseMessage.includes('experiment') ? 'warn' : 'success';
      this.$notify({ type: notificationType, title: responseMessage });
    },
  },
};
